import { create } from 'zustand'
import type { PublicUser } from '@yadviga/shared'

interface SessionState {
  user: PublicUser | null
  jwt: string | null
  /** Pre-built referral deeplink for this user, returned by /auth/init. Used
   *  as the default URL for share buttons across the app. */
  referralLink: string | null
  setSession: (s: { user: PublicUser; jwt: string; referralLink?: string }) => void
  clearSession: () => void
}

export const useSession = create<SessionState>((set) => ({
  user: null,
  jwt: null,
  referralLink: null,
  // referralLink is optional in updates — call-sites refreshing the profile
  // (after PATCH /users/me etc.) don't have it handy and shouldn't have to.
  // Only the initial /auth/init handler supplies it.
  setSession: ({ user, jwt, referralLink }) =>
    set((prev) => ({
      user,
      jwt,
      referralLink: referralLink !== undefined ? referralLink : prev.referralLink,
    })),
  clearSession: () => set({ user: null, jwt: null, referralLink: null }),
}))
